import * as React from 'react';

import classnames from 'classnames';

import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from 'shells/icon/svg/loading-icon';

import {useGetSavedFilterCount} from '../graphql/hooks/use-get-saved-filter-count';
import type {NavItemObj} from '../types';

import {ProcessingSpinner} from './processing-spinner';

import styles from './count.module.css';

type Props = {
    navItem: NavItemObj;
};

export function Count(props: Props) {
    const {navItem} = props;

    const [isProcessing, setIsProcessing] = React.useState(false);

    const {savedFilterCount, isLoading} = useGetSavedFilterCount(navItem.countUrl);

    React.useEffect(() => {
        if (navItem.type !== 'audience') {
            return;
        }

        if (navItem.isProcessing) {
            setIsProcessing(true);
        }

        if (!navItem.isProcessing && isProcessing) {
            setIsProcessing(false);

            if (navItem.isActive) {
                // We need to let the entity list container know that it should refetch the page
                window.dispatchEvent(new Event(Nut.events.global.refetchEntityListPage));
            }
        }
    }, [navItem, isProcessing]);

    if (navItem.type === 'audience' && navItem.isProcessing && navItem.id) {
        return <ProcessingSpinner id={navItem.id} />;
    }

    // We prioritize the count over the countUrl because it represents the current count of the list (i.e., the user may be filtering the list)
    if (props.navItem.count) {
        const count = props.navItem.count;

        const countStyleNames = classnames(styles.count, {
            [styles['count--not-active']]: !props.navItem.isActive,
        });

        return <span className={countStyleNames}>{`${count.formatted}${count.suffix}`}</span>;
    }

    if (props.navItem.countUrl) {
        if (isLoading) {
            return <LoadingIcon size={12} fill={colors.blueDk} />;
        }

        if (savedFilterCount) {
            return (
                <span
                    className={styles.count}
                >{`${savedFilterCount.formatted}${savedFilterCount.suffix}`}</span>
            );
        }

        return null;
    }

    return null;
}
